import * as Sentry from '@sentry/react';
import { FC } from 'react';
import { isLocalhost } from 'common/utils/RuntimeEnvironment';

export const profileComponent = (component: FC<any>) => {
    return isLocalhost ? component : Sentry.withProfiler(component);
};
